import axios from './axios';
import config from '../config/configJS';

export function getChatSessions(userId) {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/chathistory/sessions/' + userId, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}

export function getTokenUsage() {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/chathistory/token-usage', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}

export function getUserTokenUsageDetail(userId) {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/chathistory/token-usage/' + userId, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}

export function getChatMessages(sessionId) {
  return new Promise((resolve, reject) => {
    axios
      .get(config.endPoint + '/api/chathistory/sessions/' + sessionId + '/messages', {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}

export function generateSessionTitle(sessionId) {
  return new Promise((resolve, reject) => {
    axios
      .post(config.endPoint + '/api/chathistory/sessions/' + sessionId + '/generatetitle', null, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}

export function pinChatSession(sessionId) {
  return new Promise((resolve, reject) => {
    axios
      .put(config.endPoint + '/api/chathistory/sessions/' + sessionId + '/pin', null, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}

export function renameChatSession(sessionId, title) {
  return new Promise((resolve, reject) => {
    axios
      .put(config.endPoint + '/api/chathistory/sessions/' + sessionId, { Title: title }, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}

export function deleteChatSession(sessionId) {
  return new Promise((resolve, reject) => {
    axios
      .delete(config.endPoint + '/api/chathistory/sessions/' + sessionId, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        withCredentials: true,
      })
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        console.error(error);
        reject(error);
      });
  });
}
